import React,{useEffect} from 'react'
import {  Link } from "react-router-dom";
import { useLocation } from 'react-router-dom'

export default function Index() {
  const location = useLocation();
  useEffect(() => {
    console.log(location.pathname);
  },[]);
  return (
    <div className="appBottomMenu">
    <Link to="/home" className={`item  ${(location.pathname == '/home' && 'active')}`}>
      <div className="col">
        <ion-icon name="pie-chart-outline" />
        <strong>Overview</strong>
      </div>
    </Link>
    <Link to="/Product" className={`item  ${(location.pathname == '/Product' && 'active')}`}>
      <div className="col">
      <ion-icon name="cart-outline"></ion-icon>
        <strong>Product</strong>
      </div>
    </Link>
    
    <Link to="/Transaction" className={`item  ${(location.pathname == '/Transaction' && 'active')}`}>
      <div className="col">
        <ion-icon name="card-outline" />
        <strong>My Transaction</strong>
      </div>
    </Link>
    <Link to="/Settings" className={`item  ${(location.pathname == '/Settings' && 'active')}`}>
      <div className="col">
        <ion-icon name="settings-outline" />
        <strong>Settings</strong>
      </div>
    </Link>
  </div>
  
  )
}
